import { Grid, GridItem, Text, useColorModeValue } from '@chakra-ui/react';
import type { GridProps } from '@chakra-ui/react';
import React from 'react';

import { colors } from '~/packages/common-frontend/colors';

type InfoCardProps = {
  icon: React.ReactElement;
  title: string;
  value: React.ReactNode;
} & GridProps;
export const InfoCard = ({
  icon,
  title,
  value,
  borderRadius,
  borderColor,
  border,
  backgroundColor,
  bgColor,
  ...otherGridProps
}: InfoCardProps) => {
  const defaultBorderColor = useColorModeValue(colors.gray[200], colors.white);
  const defaultTitleColor = useColorModeValue(colors.black[70], colors.white);
  const defaultValueColor = useColorModeValue(colors.black[95], colors.white);
  const defaultBackgroundColor = useColorModeValue(colors.white, colors.black);

  return (
    <Grid
      {...otherGridProps}
      gridTemplateColumns="repeat(8, 1fr)"
      borderRadius={borderRadius || '8px'}
      p="16px 24px"
      bgColor={backgroundColor || bgColor || defaultBackgroundColor}
      border={border || '1px solid'}
      borderColor={borderColor || defaultBorderColor}
    >
      <GridItem gridRow="1/3" gridColumn="1" m="auto 0">
        {icon}
      </GridItem>
      <GridItem gridRow="1" gridColumn="2/-1">
        <Text color={defaultTitleColor} size="small">
          {title}
        </Text>
      </GridItem>
      <GridItem gridRow="2" gridColumn="2/-1">
        {typeof value === 'string' ? (
          <Text color={defaultValueColor} fontSize="20px" fontWeight="600px">
            {value}
          </Text>
        ) : (
          value
        )}
      </GridItem>
    </Grid>
  );
};
